import { isEmpty } from 'lodash';
import { TPaymentPeriod } from '../../types/payment-data-types';
import { THideDayColumns, TTaxSummary } from '../../types/reporting-history-types';
import { EmptyReportingPeriod } from './empty-reporting-period';
import { PeriodHeader } from './modules/period-header';
import { PeriodPayment } from './modules/period-payment';
import { ReportingHistoryItemContainer } from './styles';
import { TSupportedLocales } from './utils';

type TReportingHistoryItemProps = TPaymentPeriod & THideDayColumns & {
  locale: TSupportedLocales;
  breakdownConfig: TTaxSummary;
}

export function ReportingHistoryItem(props: TReportingHistoryItemProps) {
  const reportingPeriodIsEmpty = isEmpty(props.payments);

  if (reportingPeriodIsEmpty) return <EmptyReportingPeriod {...props} />;

  return (
    <ReportingHistoryItemContainer>
      {/* This is the header row of the payment period, It is only rendered once. */}
      <PeriodHeader 
        label={props.label} 
        hideDayColumns={props.hideDayColumns}
      />

      {props.payments.map((payment, index) => (
        <PeriodPayment 
          key={payment.paymentId}
          index={index}
          paymentData={payment}
          locale={props.locale}
          hideDayColumns={props.hideDayColumns}
          breakdownConfig={props.breakdownConfig}
        />
      ))}
    </ReportingHistoryItemContainer>
  );
}